import TokenInput from './TokenInput';

export default TokenInput;



// WEBPACK FOOTER //
// ./src/index.js